// the opposite of a noscript tag
document.querySelectorAll('.show-on-js').forEach((v)=>{
    v.classList.remove('hidden');
    v.classList.remove('show-on-js');
});

//# sourceMappingURL=show-on-js.51485c7a.js.map
